// Helper indirizzo completo cliente per appuntamenti e Google Calendar.
export function buildFullAddress(c) {
  if (!c) return "";
  const street = [c.address, c.civico].filter(Boolean).join(" ").trim();
  const tail = [c.cap, c.comune].filter(Boolean).join(" ").trim();
  const prov = (c.provincia || "").trim() ? `(${c.provincia.trim()})` : "";
  const full = [street, tail].filter(Boolean).join(", ");
  return (full + (prov ? ` ${prov}` : "")).trim();
}

export function isAddressComplete(c) {
  return !!(c && (c.address || "").trim() && (c.comune || "").trim());
}
